import React, { useState, useEffect } from 'react';
import { Form, Select, Typography, Radio, Row, Col, Tooltip } from 'antd';

const { Option } = Select;
const { Text } = Typography;

const PotentialMetrices = ({ ability, aspiration, adaptability, onAbilityChange, onAspirationChange, onAdapatabilityChange }) => {

  const [selectedValues, setSelectedValues] = useState([]);
  const [average, setAverage] = useState(null);

  console.log('PotentialMetrices received props:', { ability, aspiration, adaptability });

  useEffect(() => {
    /* console.log('ability:', ability);
    console.log('aspiration:', aspiration);
    console.log('adaptability:', adaptability);
 */

    // Calculate the average whenever selectedValues changes
    const numericValues = Object.values(selectedValues).map((value) => parseFloat(value));

    const validNumericValues = numericValues.filter((value) => !isNaN(value));

    if (validNumericValues.length > 0) {
      const sum = validNumericValues.reduce((acc, currentValue) => acc + currentValue, 0);
      const averageValue = sum / validNumericValues.length;
      setAverage(averageValue);
    } else {
      setAverage(null);
    }
  }, [selectedValues]);

  const handleSelectChange = (dropdownName, value) => {
    setSelectedValues((prevSelectedValues) => ({
      ...prevSelectedValues,
      [dropdownName]: value,
    }));
  };



  const [selectedValue, setSelectedValue] = useState('');

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleAbilityChange = (value) => {
    onAbilityChange(value); // Call the change handler passed from AssessmentPage
  };



  return (
    <div>
      <style>
        {`          
          .ability-tooltip .ant-tooltip-inner,
          .aspiration-tooltip .ant-tooltip-inner,
          .engagement-tooltip .ant-tooltip-inner {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            color: white;
            border-radius: 8px;
            box-shadow: 0 4px 12px rgba(0,0,0,0.15);
            padding: 8px 12px;
            font-size: 13px;
            line-height: 1.4;
          }
        `}
      </style>


      <Form
        name="ant_design_dropdown_form"
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={8}>
            <Form.Item 
              label={
                <Tooltip 
                  title="Demonstrated knowledge, skills, and experience acquired, and their effective application in the role"
                  placement="top"
                  mouseEnterDelay={0}
                  mouseLeaveDelay={0}
                  overlayClassName="ability-tooltip"
                >
                  <span 
                    style={{ 
                      fontWeight: 'bold', 
                      color: '#333'
                    }}
                  >
                    Ability<span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span>
                  </span>
                </Tooltip>
              }
            >
              <Select 
                value={ability} 
                onChange={onAbilityChange} 
                style={{ width: '100%' }} 
                placeholder="Select ability level"
                size="large"
              >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item 
              label={
                <Tooltip 
                  title="Displays drive in the role, eagerness to grow as an SME, and readiness to take on more complex and challenging responsibilities."
                  placement="top"
                  mouseEnterDelay={0}
                  mouseLeaveDelay={0}
                  overlayClassName="aspiration-tooltip"
                >
                  <span 
                    style={{ 
                      fontWeight: 'bold', 
                      color: '#333'
                    }}
                  >
                    Aspiration<span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span>
                  </span>
                </Tooltip>
              }
            >
              <Select 
                value={aspiration} 
                onChange={onAspirationChange} 
                style={{ width: '100%' }} 
                placeholder="Select aspiration level"
                size="large"
              >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={8}>
            <Form.Item 
              label={
                <Tooltip 
                  title="Effectively responds to pressure, and demonstrates the ability to guide the team through ambiguity and uncertainty."
                  placement="top"
                  mouseEnterDelay={0}
                  mouseLeaveDelay={0}
                  overlayClassName="engagement-tooltip"
                >
                  <span 
                    style={{ 
                      fontWeight: 'bold', 
                      color: '#333'
                    }}
                  >
                    Engagement<span style={{ color: '#ff4d4f', marginLeft: '4px' }}>*</span>
                  </span>
                </Tooltip>
              }
            >
              <Select 
                value={adaptability} 
                onChange={onAdapatabilityChange} 
                style={{ width: '100%' }} 
                placeholder="Select engagement level"
                size="large"
              >
                <Option value="5">Eager to Expand</Option>
                <Option value="4">Ready for More</Option>
                <Option value="3">Successful</Option>
                <Option value="2">Maxed Out</Option>
                <Option value="1">Inconsistent</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>




      </Form>




    </div>
  );
};

export default PotentialMetrices;